var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"clip"}},[_c('navbar'),_c('Skeleton',{attrs:{"loading":_vm.isloading}}),(!_vm.isloading)?_c('span',[_c('Business',{key:_vm.foll_id,staticClass:"wahala"}),_c('Footer')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }